import type { Story } from '../data'
import { storyRenderMode } from './render-mode'

/** The server remains authoritative; these states prevent an obviously unusable profile from starting a conversion. */
export function conversionReferenceIssue(story: Story, status?: string): string | null {
  if (storyRenderMode(story) !== 'voice_conversion') return null
  if (status === 'rerecord_required') return '새 목소리 변환 방식에 맞게 부모 목소리를 다시 녹음해 주세요. 이전에 만든 동화는 그대로 들을 수 있어요.'
  if (status === 'synthetic_preview') return '이 목소리는 원본 녹음이 없어 부모님의 실제 음색으로 변환할 수 없어요. 다시 녹음해 주세요.'
  if (status === 'unavailable') return '변환에 사용할 부모 목소리 원본을 찾지 못했어요. 목소리를 다시 등록해 주세요.'
  return null
}
